// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2oMEV","col":"Table_col__1uYM1","fulfillmentStatus":"Table_fulfillmentStatus__3KQYS","emailCol":"Table_emailCol__1IXSF"};